/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Priyadharshini",
  title: "Hello, I'm Priyadharshini",
  subTitle: emoji(
    "A passionate Software Developer 🚀 with experience in building user friendly and efficient applications. I enjoy solving problems, learning new technologies, and contributing to impactful projects."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1TvkXkIVDLk9I8hoobYKPIvahTV34pcWq/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Priyadharshini0101",
  linkedin: "https://www.linkedin.com/in/priyadharshini-s-0323a7212/",
  gmail: "priyadharshinis5102@gmail.com",
  instagram: "https://www.instagram.com/dharshini_0101",
  twitter: "https://x.com/dharshini0101", 
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Tech Stack",
  subTitle: "Passionate developer eager to learn, grow, strengthen technical skills",
  skills: [
    emoji(
      "⚡  Design, build, and maintain high performance, reusable, and reliable application" 
    ),
    emoji(
      "⚡ Good at problem solving skills"
    ),
    emoji("⚡ Flexible team player who prospers in a fast-paced data driven environment"),
    emoji("⚡ Good communication and collaborative skills")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C",
      imgSrc:'../../assets/stack/C.svg'
    },
    {
      skillName: "C++",
      imgSrc:'../../assets/stack/C.svg'
    },
    {
      skillName: "HTML5",
      imgSrc: '../../assets/stack/C.svg'
    },
    {
      skillName:"java",
      fontAwesomeClassname: "fab fa-java",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Government College of Engineering, Salem",
      logo: require("./assets/stack/gceSalem.png"),
      subHeader: "B.E - Computer Science and Engineering",
      duration: "July 2019 - May 2023",
      grade: 'Average CGPA - 9.1',
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Internship - Android App Development",
      company: "Exposys Data Labs",
      companylogo: require("./assets/stack/exposysDataLabs.jpg"),
      date: "Oct 2021 - Nov 2021",
      desc: "Developed an Android chat application that connects people with similar interests. Implemented a filtering feature to display users with shared interests on the home page.",
    },
    {
      role: "Project Trainee - Web Client",
      company: "Zoho",
      companylogo: require("./assets/stack/zoho.jpg"),
      date: "Nov 2022 - Mar 2023",
      desc: "Learned frontend development, collaborated on frontend development tasks and developed an Expense Tracker to track user balances."
    },
    {
      role: "Internship - Full Stack Development",
      company: "Nila Apps",
      companylogo: require("./assets/stack/nilaApps.jpg"),
      date: "Jul 2023 - Oct 2023",
      desc: "Developed a Room Booking System with authentication for customers and owners. Enabled owners to manage bookings and customers to track room availability easily."
    },
    
    {
      role: "Frontend Developer Consultant - Frontend Development",
      company: "Solytics Partners",
      companylogo: require("./assets/stack/solyticsPartners.jpg"),
      date: "Aug 2024 - Feb 2025",
      desc: "Worked on bug fixes, tasks, and logger issues, resolving 80+ tickets related to UI enhancements and feature updates. Debugged and fixed critical issues in the Nimbus-Frontend website, improving user experience and performance."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/stack/UFarm.png"),
      projectName: "U-Farm App",
      projectDesc: " A mobile-friendly agricultural support app where farmers upload disease affected crop photos and receive expert solutions via text and audio in native languages. Solved real-world problems by providing timely and accurate solutions to farmers, improving crop yield and productivity.",
      footerLink: [
        {
          name: "Visit Website",
          url: "",
          githubUrl:"https://github.com/Priyadharshini0101/U-Farm"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/stack/Stop-N-Shop.png"),
      projectName: "Stop ‘N Shop",
      projectDesc: "An e-commerce platform for clothing stores that allows users to browse products, add items to a cart, and proceed to checkout for delivery. Includes user authentication, preference saving, and order tracking features for a personalized shopping experience",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://stop-n-shop-hf36xm3gb-priyadharshinis-projects-a027af97.vercel.app/",
          githubUrl:'https://github.com/Priyadharshini0101/Stop-N-Shop'
        }
      ]
    },
    {
      image: require("./assets/stack/Netflix-Clone.png"),
      projectName: "Netflix-Clone",
      projectDesc: " A Netflix-inspired streaming platform built using React.js and the TMDB API. Features include user authentication, personalized watchlists, and content filtering by language and genre",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://netflix-clone-one-coral-26.vercel.app/",
          githubUrl:"https://github.com/Priyadharshini0101/Netflix-Clone",
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
